import { useRef } from "react";
import ModalPop from "./ModalPop";
import menuOnClick from "../common/menuOnClick";

interface DetailItem {
  badge: string;
  lineNormal: string;
  lineHighlight: string;
  description: string;
  icon: string;
}

const details: DetailItem[] = [
  {
    badge: "하나",
    lineNormal: "바우하우스는 전국 지사망을 통해 고객님께",
    lineHighlight: "출장비 없는 출장견적을 지원합니다!",
    description: "문의 후 가장 가까운 지사에서 고객님의 주소로 바로 달려갑니다",
    icon: "/images/icon1.png",
  },
  {
    badge: "둘",
    lineNormal: "바우하우스는 필요한 견적만 정확히 산출하여",
    lineHighlight: "불필요한 견적이 나오지 않도록 합니다!",
    description: "정확한 견적산출로 고객님의 부담을 한층 덜어드리겠습니다",
    icon: "/images/icon2.png",
  },
  {
    badge: "셋",
    lineNormal: "바우하우스의 인력은 감히 최고라 자부하여",
    lineHighlight: "어떤 현장 어떤 공간도 100% 해결합니다!",
    description: "오랜\u00A0경력과\u00A0무수히\u00A0많은\u00A0경험으로 무장한 최고의\u00A0인력이\u00A0준비중입니다",
    icon: "/images/icon3.png",
  },
  {
    badge: "넷",
    lineNormal: "작업진행 후 미흡한 진행건이 있었다면?",
    lineHighlight: "신속하게 달려가 완벽하게 A/S 해드립니다!",
    description: "서비스에\u00A0불만족하시는\u00A0고객님이\u00A0없도록 최선을\u00A0다하겠습니다",
    icon: "/images/icon4.png",
  },
];

export function BenefitsDetail() {
  const popupRef = useRef<HTMLDivElement>(null);

  const openfunc = () => {
    popupRef.current!.style.display = "block";
  };

  const closefunc = () => {
    popupRef.current!.style.display = "none";
  };

  return (
    <>
      <section className="w-full bg-white pt-8 lg:pt-16">
        <div className="mx-auto max-w-[890px]">
          {/* Numbered rows */}
          <div className="flex flex-col gap-10 md:gap-14 text-center md:text-left">
            {details.map((item) => (
              <div
                key={item.badge}
                data-aos="fade-up"
                className="flex items-center justify-between flex-wrap-reverse lg:flex-nowrap gap-3 md:gap-6 w-full"
              >
                <div className="lg:flex items-start w-full lg:gap-4">
                  <span className="hidden relative w-fit h-fit md:inline-block rounded-full bg-primary px-4 pt-1 text-xs text-white md:px-5 md:text-sm mt-4">
                    {item.badge}
                  </span>
                  <div>
                    <p className="mt-3 text-base leading-tight sm:text-lg md:text-2xl">
                      {item.lineNormal}
                      <br />
                      <span className="text-primary">{item.lineHighlight}</span>
                    </p>
                    <p className="mt-4 lg:mt-7 text-xs sm:text-sm md:text-base">{item.description}</p>
                  </div>
                </div>
                <img
                  src={item.icon}
                  alt=""
                  aria-hidden="true"
                  className="h-16 w-16 shrink-0 object-contain sm:h-20 sm:w-20 md:h-28 md:w-28 mx-auto lg:mx-0"
                />
              </div>
            ))}
          </div>

          {/* CTA buttons */}
          <div className="mt-14 grid lg:grid-cols-2 gap-3 md:mt-20 max-w-[700px] mx-auto">
            <a
              href="/#banner"
              onClick={(e) => {
                if (document.getElementById("banner")) {
                  e.preventDefault();
                  menuOnClick("#banner");
                }
              }}
              className="w-full rounded-full bg-primary pt-2 pb-1 text-center text-sm text-white transition-colors hover:bg-[#e0690f] sm:w-auto md:text-base"
            >
              출장비 없는 출장견적 신청 바로가기
            </a>
            <button
              onClick={openfunc}
              className="w-full rounded-full border-2 border-primary pt-2 pb-1 text-center text-sm text-primary transition-colors hover:bg-orange-50 sm:w-auto md:text-base"
            >
              상세견적문의 바로가기
            </button>
          </div>
        </div>
      </section>
      <ModalPop popupRef={popupRef} closefnc={closefunc} />
    </>
  );
}

interface Benefit {
  icon: string;
  title: string;
  highlight: string;
}

const benefits: Benefit[] = [
  { icon: "/images/service1.png", title: "출장비", highlight: "ZERO" },
  {
    icon: "/images/service2.png",
    title: "과잉견적",
    highlight: "절대 X",
  },
  {
    icon: "/images/service3.png",
    title: "최고의 인력",
    highlight: "BEST",
  },
  {
    icon: "/images/service4.png",
    title: "미흡한 진행건",
    highlight: "A/S",
  },
];

const About = () => {
  return (
    <div
      id="benefits"
      className="relative w-full h-full px-[calc((100%-var(--container))/4)] mx-auto py-14 lg:py-28 xl:py-36"
    >
      <div className="mx-auto max-w-[1200px] px-4 md:px-8">
        {/* Heading */}
        <div className="text-center">
          <p className="text-lg lg:text-xl">나는 어떤 혜택들을 받을 수 있나요?</p>
          <h2 className="mt-2 text-3xl md:text-4xl xl:text-5xl">
            <span className="font-light">바우하우스</span> <span className="text-primary">혜택 4가지</span>
          </h2>
        </div>

        {/* Card */}
        <div
          data-aos="fade-up"
          className="mt-8 rounded-3xl border-2 border-primary px-6 py-10 md:mt-10 md:px-12 md:py-12"
        >
          <div className="text-center">
            <p className="text-lg md:text-2xl xl:text-3xl">
              <span className="text-primary">답답</span>하고 <span className="text-primary">막막</span>하기만 했던{" "}
              <span className="text-primary">유품정리&nbsp;·&nbsp;특수청소</span>
            </p>
            <p className="mt-2 text-sm md:text-base xl:text-xl">
              바우하우스와&nbsp;함께 손해보지&nbsp;않고 깔끔하게&nbsp;해결해보세요
            </p>
          </div>

          {/* Icon grid */}
          <div className="mt-10 grid grid-cols-2 gap-y-8 md:mt-14 md:grid-cols-4 md:gap-y-0">
            {benefits.map((benefit) => (
              <div key={benefit.title} className="flex flex-col items-center gap-4 px-2 text-center">
                <img
                  src={benefit.icon}
                  alt={`${benefit.title} ${benefit.highlight}`}
                  className="h-24 w-24 md:h-28 md:w-28 lg:h-32 lg:w-32"
                />
                <p className="text-sm font-medium md:text-base xl:text-lg !leading-tight">
                  {benefit.title}
                  <br />
                  <span className="text-primary">{benefit.highlight}</span>
                </p>
              </div>
            ))}
          </div>
        </div>

        {/* discrip */}
        <BenefitsDetail />
      </div>
    </div>
  );
};

export default About;
